import axios from 'axios'
import decryptData from '@/store/auth/decryptData'

export default {
  namespaced: true,
  state: () => ({
    productMap: {}, // store by ID: { [id]: productArray } — 'all' key for no certificate
  }),
  mutations: {
    SET_PRODUCTS(state, { id, products }) {
      state.productMap[id] = products
    },
  },
  actions: {
    async fetchProducts({ state, commit }, id) {
      if (state.productMap[id]) return

      const res = await axios.get(`personnel-evaluation/${id}/products`)
      const { data } = decryptData(res.data.payload)
      const formatted = data.map(item => ({
        value: item.name,
        text: item.name,
      }))

      commit('SET_PRODUCTS', { id, products: formatted })
    },

    async fetchAllProducts({ state, commit }) {
      if (state.productMap.all) return

      const res = await axios.get('product-categories')
      const { data } = decryptData(res.data.payload)
      const formatted = data.productCategories.map(item => ({
        value: item.name,
        text: item.name,
      }))

      commit('SET_PRODUCTS', { id: 'all', products: formatted })
    },
  },
  getters: {
    getProductsById: state => id => state.productMap[id] || [],
  },
}
